import { useEffect, useRef } from "react";

export const useFocus = (shouldFocus = true) => {
    const inputRef = useRef<HTMLInputElement>(null);

    useEffect(() => {
        // focus on the input if present.
        if (shouldFocus) {
            inputRef.current?.focus();
        }
    }, [shouldFocus]);

    return inputRef;
};
